import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=e8b5fc12&scoped=true&"
var script = {}
import style0 from "./Alert.vue?vue&type=style&index=0&id=e8b5fc12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b5fc12",
  null
  
)

export default component.exports